




















































import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState } from "vuex";

// Model
import { LicenseModuleStatusEnum } from "@/model/data/License/LicenseModuleStatusEnum";
import { stretchingWindowAfterExpiration } from "@/model/data/License/LicenseModule";
import { getLicenseModuleIconColor } from "@/utility/Constants";
import { getLicenseModuleLabel, defaultLicenseModuleEnumSorting, LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";

export default Vue.extend({
    data() {
        return {
            headers: [
                {
                    value: "module",
                    text: this.$t("licensesManagement.module"),
                    sortable: false,
                },
                {
                    value: "status",
                    text: this.$t("common.status"),
                    sortable: false,
                    align: "center",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            licensesData: (state: RootState) => state.license.licenseModules,
        }),

        items() {
            var arrayResult = [];

            this.defaultLicenseModuleEnumSorting().forEach((moduleEnumValue) => {
                if (
                    this.licensesData.modules.filter((c) => c.module == moduleEnumValue).length > 0 &&
                    this.licensesData.modules.filter((c) => c.module == moduleEnumValue)[0].nDevices > 0
                )
                    arrayResult.push(this.licensesData.modules.filter((c) => c.module == moduleEnumValue)[0]);
            });

            return arrayResult;
        },

        content() {
            return this.getStyle(this.licensesData.modules[0].getStatus());
        },
    },
    methods: {
        getLicenseModuleLabel,
        defaultLicenseModuleEnumSorting,
        getLicenseModuleIconColor,

        getStyle(status: LicenseModuleStatusEnum) {
            switch (status) {
                case LicenseModuleStatusEnum.Valid:
                    return { icon: "thumbs-up", color: "success", text: this.$t("license.license_active") };
                case LicenseModuleStatusEnum.CloseToExpiration:
                    return {
                        icon: "exclamation-triangle",
                        color: "warning",
                        text: this.$tc("license.license_will_expire_in_days", Math.abs(this.licensesData.modules[0].getExpirationDateDiff())),
                    };
                case LicenseModuleStatusEnum.ExpiredRecently:
                    return {
                        icon: "exclamation-triangle",
                        color: "error",
                        text:
                            this.$t("license.license_is_expired") +
                            ". " +
                            this.$tc("license.you_can_still_use_clink_for_days", stretchingWindowAfterExpiration - Math.abs(this.licensesData.modules[0].getExpirationDateDiff())),
                    };
                case LicenseModuleStatusEnum.Expired:
                    return { icon: "times-circle", color: "error", text: this.$t("license.license_is_expired") };
                default:
                    return { icon: "thumbs-up", color: "success" };
            }
        },
    },
});
